module.exports = __webpack_public_path__ + "static/3-807eea7a64f844d3bfe24a498b907e2b.jpeg";